import React from 'react';
import { CONCEPTS } from '../../constants/concepts';

const ConceptSelector = ({ selectedConcept, onConceptSelect }) => {
    return (
        <div className="mb-6">
            <div className="flex flex-wrap gap-4 text-sm">
                {CONCEPTS.map(({ id, name }) => (
                    <div
                        key={id}
                        className={`
              relative cursor-pointer p-4 w-32 rounded-lg
              flex items-center justify-center text-center
              transition-all duration-300 transform-none
              ${selectedConcept === id
                                ? 'border-2 border-secondary bg-background shadow-lg'
                                : 'border border-primary/30 hover:border-secondary'}
              before:absolute before:inset-0 before:rounded-lg
              before:transition-all before:duration-300
              hover:shadow-xl
              group
            `}
                        onClick={() => onConceptSelect(id)}
                    >
                        <span className={`
              block font-semibold transition-colors duration-300
              ${selectedConcept === id ? 'text-secondary' : 'text-primary group-hover:text-secondary'}
              relative z-10
            `}>
                            {name}
                        </span>
                        {selectedConcept === id && (
                            <div className="absolute inset-0 bg-gradient-to-r from-accent/5 to-secondary/5 rounded-lg animate-pulse" />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ConceptSelector;